export const EMPLOYEES_SET_LOADING = 'EMPLOYEES/SET_LOADING';
export const EMPLOYEES_SET_ERROR = 'EMPLOYEES/SET_ERROR';
export const EMPLOYEES_SET_EMPLOYEE = 'EMPLOYEES/SET_EMPLOYEE';

export const EMPLOYEES_FETCH_EMPLOYEE = 'EMPLOYEES/FETCH_EMPLOYEE';
export const EMPLOYEES_CLEAR_ERROR = 'EMPLOYEES/CLEAR_ERROR';

export const EMPLOYEES_GET_EMPLOYEE = 'EMPLOYEES/GET_EMPLOYEE';
export const EMPLOYEES_GET_LOADING = 'EMPLOYEES/GET_LOADING';
export const EMPLOYEES_GET_ERROR = 'EMPLOYEES/GET_ERROR';
